import { useState, useEffect } from "react";
import { getCustomerAppSessionStorageKey } from "checkout/util/constants";

const readSessionFlag = (prospectId: string, offerId: string) => {
  if (typeof window !== "undefined" && prospectId) {
    const key = getCustomerAppSessionStorageKey(prospectId, offerId);
    return sessionStorage.getItem(key) === "true";
  }
  return false;
};

const useCustomerAppSessionFlag = (prospectId: string, offerId: string) => {
  const [flag, setFlagState] = useState(() =>
    readSessionFlag(prospectId, offerId)
  );

  useEffect(() => {
    if (!prospectId) return;
    setFlagState(readSessionFlag(prospectId, offerId));
  }, [prospectId, offerId]);

  const setFlag = (value: boolean) => {
    setFlagState(value);

    if (!prospectId || !offerId || typeof window === "undefined") return;

    const sessionStorageKey = getCustomerAppSessionStorageKey(
      prospectId,
      offerId
    );

    if (value) {
      sessionStorage.setItem(sessionStorageKey, "true");
    } else {
      sessionStorage.removeItem(sessionStorageKey);
    }
  };

  return [flag, setFlag] as const;
};

export { useCustomerAppSessionFlag };
